import { jsxs as y, jsx as e } from "react/jsx-runtime";
import v from "clsx";
import { Slot as x, Slottable as f } from "@radix-ui/react-slot";
import { forwardRef as z } from "react";
import '../../assets/anchor.css';const k = "_anchor_10g49_1", u = "_anchor__icon_10g49_72", o = {
  anchor: k,
  "anchor--color-inherit": "_anchor--color-inherit_10g49_23",
  "anchor--size-inherit": "_anchor--size-inherit_10g49_27",
  "anchor--size-sm": "_anchor--size-sm_10g49_48",
  "anchor--icon-position-start": "_anchor--icon-position-start_10g49_53",
  "anchor--icon-position-end": "_anchor--icon-position-end_10g49_54",
  "anchor--is-image": "_anchor--is-image_10g49_59",
  "anchor--decoration-none": "_anchor--decoration-none_10g49_65",
  "anchor--decoration-hover": "_anchor--decoration-hover_10g49_66",
  anchor__icon: u,
  "anchor--icon-only": "_anchor--icon-only_10g49_88",
  "anchor--icon-only-sm-down": "_anchor--icon-only-sm-down_10g49_112",
  "anchor--icon-only-md-down": "_anchor--icon-only-md-down_10g49_134",
  "anchor--icon": "_anchor--icon_10g49_53",
  "anchor--relative": "_anchor--relative_10g49_159",
  "anchor--expand": "_anchor--expand_10g49_163",
  "anchor--color-light": "_anchor--color-light_10g49_171",
  "anchor--color-dark": "_anchor--color-dark_10g49_177"
}, N = z(
  ({
    asChild: t,
    children: s,
    icon: n,
    color: r,
    className: d = "",
    decoration: a,
    expand: l,
    size: h,
    iconPosition: i,
    iconOnly: c,
    isImage: m,
    href: _,
    relative: g,
    ...p
  }, w) => /* @__PURE__ */ y(
    t ? x : "a",
    {
      href: _ || void 0,
      className: v(
        {
          [o.anchor]: !0,
          [o["anchor--relative"]]: g,
          [o["anchor--color-inherit"]]: r === "inherit",
          [o["anchor--color-light"]]: r === "light",
          [o["anchor--color-dark"]]: r === "dark",
          [o["anchor--size-sm"]]: h === "sm",
          [o["anchor--size-inherit"]]: h === "inherit",
          [o["anchor--is-image"]]: m,
          [o["anchor--expand"]]: l,
          [o["anchor--decoration-hover"]]: a === "hover",
          [o["anchor--decoration-none"]]: a === "none",
          [o["anchor--icon-only"]]: c === !0,
          [o["anchor--icon-only-md-down"]]: c === "md-down",
          [o["anchor--icon-only-sm-down"]]: c === "sm-down",
          [o["anchor--icon"]]: n,
          [o["anchor--icon-position-start"]]: i === "start",
          [o["anchor--icon-position-end"]]: i === "end"
        },
        d
      ),
      ref: w,
      ...p,
      children: [
        /* @__PURE__ */ e(f, { children: s }),
        n && /* @__PURE__ */ e("span", { className: o.anchor__icon, children: n })
      ]
    }
  )
);
N.displayName = "Anchor";
export {
  N as Anchor
};
